import { createFileRoute } from '@tanstack/react-router'
import { PrivacyPage } from '_/features/legal/ui/legal-page'

// Public on purpose: Google's OAuth consent screen links here, so it must
// never sit behind AuthGuard.
export const Route = createFileRoute('/privacy')({
	staticData: { title: 'legal_privacy_title' },
	component: PrivacyPage,
})
